/**
 * 前端页面缓存的版本号，如果想前端强制刷新页面的缓存，就改一下发版本
 *
 * 1.0.1 - 组件迁移，版本号变更需要强制刷新下页面缓存，避免组件显示异常
 * 1.0.2 - 个别组件缓存的数据有误，但存在问题的页面和访问过的用户较多，统一更新一次
 * 1.0.3 - entrance接口后端返回主题关联的组件样式和组件样式，页面主题相关逻辑调整至前端去合并处理
 * 1.0.4 - 处理页面信息返回 appId 驼峰命名兼容问题
 */
const FrontCacheVersion = '1.0.4';

export default FrontCacheVersion;
